import React from 'react';
import './About.css';

const features = [
  { label: 'Healthcare Technology', desc: 'HIPAA-compliant platforms built for modern clinical workflows.' },
  { label: 'Education Technology', desc: 'Scalable academic systems trusted by schools and universities.' },
  { label: 'Cyber Security', desc: 'Enterprise-grade security and compliance at every layer.' },
  { label: 'IT Consultancy', desc: 'Strategic guidance tailored to your industry and goals.' },
];

const About = () => (
  <section id="about" className="about">
    <div className="about-inner">

      {/* Left — decorative panel */}
      <div className="about-visual fade-up">
        <div className="about-circuit">
          <div className="circuit-dot cd1"></div>
          <div className="circuit-dot cd2"></div>
          <div className="circuit-dot cd3"></div>
          <div className="circuit-line cl1"></div>
          <div className="circuit-line cl2"></div>
          <div className="circuit-line cl3"></div>
          <div className="circuit-line cl4"></div>
          <div className="about-badge-ring">
            <svg viewBox="0 0 120 120" className="about-badge-svg">
              <path id="ab-circle" d="M 60,60 m -40,0 a 40,40 0 1,1 80,0 a 40,40 0 1,1 -80,0" fill="none"/>
              <text fontSize="9" fontFamily="DM Mono, monospace" fill="rgba(14,114,227,0.6)" letterSpacing="3.5">
                <textPath href="#ab-circle">aXtion Technologies • Since 1998 •</textPath>
              </text>
            </svg>
            <div className="about-badge-center">
              <img src="/axtion-logo.png" alt="aXtion Technologies" className="about-logo-img" />
            </div>
          </div>
        </div>

        <div className="about-stat-box">
          <span className="about-stat-num">28</span>
          <span className="about-stat-label">Years of<br />Experience</span>
        </div>
      </div>

      {/* Right — content */}
      <div className="about-content fade-up">
        <span className="about-eyebrow">
          <span className="about-wave">〰〰</span> WHO WE ARE
        </span>

        <h2 className="about-heading">
          Preparing for your success —<br />
          <em>trusted source in IT services</em>
        </h2>

        <p className="about-description">
          At aXtion Technologies, our goal is to give the very best to our customers by delivering
          innovative, reliable, and high-quality technology solutions. We are committed to understanding
          our clients' needs and exceeding their expectations through continuous improvement,
          cutting-edge innovation, and exceptional service. Every product and service we provide is
          driven by our passion for excellence and our dedication to creating meaningful impact for
          the people and businesses we serve.
        </p>

        <div className="about-features">
          {features.map(f => (
            <div key={f.label} className="about-feature">
              <span className="about-check">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <circle cx="8" cy="8" r="7.5" stroke="currentColor"/>
                  <path d="M4.5 8l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <div>
                <strong>{f.label}</strong>
                <p>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="about-actions">
          <a href="#contact" className="about-btn-primary">Get Free Consultation</a>
          <a href="#services" className="about-btn-ghost">Our Solutions →</a>
        </div>
      </div>

    </div>
  </section>
);

export default About;
